'use client';
import { ReactNode } from 'react';
import { useUrlState } from '../hooks';

interface IProps {
  tabs: {
    render: () => ReactNode;
    title: string | ReactNode;
    hidden?: boolean;
  }[];
  active?: number;
  searchParamName: string;
}

export const Tabs = ({ tabs, active = 0, searchParamName }: IProps) => {
  const [activeTab, setActiveTab] = useUrlState(searchParamName, active);

  if (tabs.length < 2) {
    return tabs[0]?.render();
  }

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-row bg-gray-25 rounded-[8px] p-1">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={` ${activeTab === index ? 'bg-white rounded-[6px] shadow-tab-active font-bold' : 'text-gray-500'} text-sm transition-all px-3 py-2`}
            onClick={() => {
              setActiveTab(index);
            }}
            type="button"
            hidden={tab.hidden}
          >
            {tab.title}
          </button>
        ))}
      </div>
      {tabs[activeTab]?.render()}
    </div>
  );
};
